// Global reactive flag for whether the navbar is open.
// Uses useState for shared reactivity and keeps the value in a cookie.
export const useNavbarOpened = () => {

  const state = useState<boolean>('navbar-opened', () => {
    const cookieVal = useCook<boolean>('navbar-opened').value
    return cookieVal ?? !useClientIsMobile().value
  })
  const cookieRef = useCook<boolean>('navbar-opened')
  watch(state, (val) => {
    cookieRef.value = val
  })

  return state
}

export const useTopbarHiddenMobile = () => useState('useTopbarHiddenMobile', () => false)
export const useTopbarFixed = () => useState('useTopbarFixed', () => false)
export const useTopbarFixedScrollDown = () => useState('useTopbarFixedScrollDown', () => false)

export const useWarningMigrate = () => useState('useWarningMigrate', () => false)
export const useWarningMigrateHidden = () => useState('useWarningMigrateHidden', () => false)






export const useNavbarThemeRequired = () => useState('useNavbarThemeRequired', () => null)


export const useNavbarTheme = () => {
  // one cookie ref for the whole composable
  const cookie = useCook<string>('ui:theme')

  // global state, initialised from cookie (fallback = 'light')
  const theme = useState<string>('ui:theme', () => cookie.value ?? 'light')

  // keep cookie in sync without reallocating refs
  watch(theme, (newValue) => {
    cookie.value = newValue
  })

  return theme
}
